import React from 'react';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { AuthContext } from 'contexts';
import { Page, IconNameType, Tile } from 'components';
import { featureEnabled } from 'utils';

type ButtonItemType = {
  icon: IconNameType;
  lines: [string, string];
  to?: string;
  href?: string;
  useNewIcon?: boolean;
};

const AnsweringSettingsPage: React.FC = () => {
  const { md } = useBreakpoint();
  const { auth } = React.useContext(AuthContext);

  const buttonList: ButtonItemType[] = (
    [
      auth?.org.type === 'answering' && {
        icon: 'antdShareAltOutlined',
        lines: ['Brokerage', 'Grouping'],
        to: '/answering/brokerage-grouping',
      },
      {
        icon: 'antdUserOutlined',
        lines: ['Manage', 'Staff'],
        to: '/answering/manage-staff',
      },
      auth?.org?.type === 'mlsStaff' &&
        featureEnabled('supraAutoCoopFeature') && {
          icon: 'connectionTwoWay',
          useNewIcon: true,
          lines: ['Auto Co-op', 'Organizations'],
          to: '/mls/coop/list',
        },
    ] as ButtonItemType[]
  ).filter(Boolean);

  return (
    <Page type="hollow" title="Admin">
      <StyledGrid $isMobile={!md}>
        {buttonList.map(({ icon, lines, to, href, useNewIcon }) => {
          const key = lines.join('-');

          return (
            <Tile
              key={key}
              icon={icon}
              lines={lines}
              to={to}
              href={href}
              useNewIcon={useNewIcon}
            />
          );
        })}
      </StyledGrid>
    </Page>
  );
};

const StyledGrid = styled.div<{ $isMobile: boolean }>`
  display: grid;
  gap: 35px;
  grid-auto-rows: 112px;
  grid-template-columns: repeat(auto-fit, 235px);
  ${({ $isMobile }) =>
    $isMobile &&
    `
  grid-template-columns: 1fr;
  `}
`;

export default AnsweringSettingsPage;
